import { useContext, useState } from 'react';
import { LoginModel, UserProviderValue } from '../models';
import { UserContext } from '../contexts/user.context';
import { useForm } from 'react-hook-form';
import { LoginSchema } from '../schemas';
import { zodResolver } from '@hookform/resolvers/zod';
import { login } from '../services';
import { toast } from 'react-toastify';
import { useGoogleAuth } from './useGoogleAuth';

export function useLoginWeb2() {
   const loginForm = useForm<LoginModel>({
      resolver: zodResolver(LoginSchema),
      mode: 'onChange',
   });
   const { setUser, setIsAuthenticated, setIsLoginModalOpen } = useContext<UserProviderValue>(UserContext);

   const [isLoading, setIsLoading] = useState(false);

   const submitLogin = async (data: LoginModel) => {
      setIsLoading(true);
      const loginResponse = await login(data);

      if (loginResponse.error || !loginResponse.data) {
         toast.error(loginResponse.error?.message || 'Failed to login');
         setIsLoading(false);
         return;
      }

      setUser(loginResponse.data);
      setIsAuthenticated(true);
      setIsLoading(false);
      setIsLoginModalOpen(false);
   };

   const handleGoogleSuccess = (user: any) => {
      setUser(user);
      setIsAuthenticated(true);
      setIsLoginModalOpen(false);
   };

   const { googleButtonRef } = useGoogleAuth({
      onSuccess: handleGoogleSuccess,
      buttonText: 'signin_with',
   });

   return {
      submitLogin,
      isLoading,
      loginForm,
      setIsLoginModalOpen,
      googleButtonRef,
   };
}
